import React from 'react'
import Container from './micro-components/Container'
import Title from './micro-components/Title'

const SectionCard: React.FC<{
  id: string;
  title: string;
  children: React.ReactNode;
  description?: string;
  actions?: React.ReactNode;
}> = ({ id, title, children, description, actions }) => (
  <div id={id} className='scroll-mt-28'>
    <Container className='gap-4 shadow-sm border border-gray-100'>
      <div className='flex flex-col gap-2 min-w-full'>
        <div className='flex items-center justify-between gap-3'>
          <Title title={title} />
          {actions}
        </div>
      </div>
      {children}
    </Container>
  </div>
)

export default SectionCard

